module.exports = __webpack_public_path__ + "static/img/1058.54725e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1058.jpg
// module id = 240
// module chunks = 0